<template>
  <div>
    <div v-if="!props.isAudit" class="title" style="position: relative;">
      结算单详情
      <div style="position: absolute; right: 0;top: 0;">
        <el-popover
          v-if="isSass"
          placement="bottom-start"
          width="260px"
          trigger="click"
        >
          <template #reference>
            <el-button>
              导出
            </el-button>
          </template>
          <ul>
            <li class="flex justify-between border-solid border-b border-[#EBEEF5]  h-10 items-center">
              <div class="w-[157px]">
                结算单
              </div>
              <svg-icon class="file-icon main-primary-text mx-2 !w-4 !h-4" icon="tabler:arrow-bar-to-down" @click="exportData('order')" />
            </li>
            <li class="flex justify-between border-solid border-b border-[#EBEEF5]  h-10 items-center">
              <div class="w-[157px]">
                结算明细
              </div>
              <svg-icon class="file-icon main-primary-text mx-2 !w-4 !h-4" icon="tabler:arrow-bar-to-down" @click="exportData('detail')" />
            </li>
          </ul>
        </el-popover>
        <el-button v-else @click="exportData('order')">
          导出
        </el-button>
        <el-button v-if="state.status===0||state.status===3" type="" @click="toCancel">
          作废
        </el-button>
        <el-button v-if="state.status===0||state.status===3" type="" @click="toSubmit">
          提交
        </el-button>
      </div>
    </div>
    <div v-if="!props.isAudit" class="base-card-info p-4">
      <div class="base-info-list">
        <div class="flex justify-between w-full items-center p-2 ">
          <div class="flex items-center ">
            <img class="w-[50px] h-[50px]" src="https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/web-example/Group%203594%402x.png" alt="">
            <div class="ml-3 flex flex-col gap-y-2">
              <div class="font-bold text-[20px]">
                任务编号：{{ state.code }}
              </div>
              <div>
                <span class="text-[#8c8c8c]">结算周期</span>：{{ state.settlementDate }}
                <span class="text-[#8c8c8c] ml-4">创建人</span>：{{ state.creator }}
                <span class="text-[#8c8c8c] ml-4">创建时间</span>：{{ state.creator }}
              </div>
              <div>
                <span class="text-[#8c8c8c] ml-4">提交人</span>：{{ state.submitter }}
                <span class="text-[#8c8c8c] ml-4">提交时间</span>：{{ state.submitTime }}
              </div>
            </div>
          </div>
          <div>
            <img class="w-[150px] h-[100px]" :src="getImageUrl(state.status)" alt="">
          </div>
        </div>
      </div>
    </div>
    <div v-if="isSass" class="cw-tabs mb-0">
      <div
        v-for="v in tabs"
        :key="v.key"
        :class="{ active: activeKey === v.key }"
        @click="hanldeTab(v.key)"
      >
        {{ v.name }}
      </div>
    </div>
    <template v-if="activeKey === 'order'">
      <div v-for="(item,index) in tableData" :key="index" class="base-card-info p-4">
        <div class="info-card-title">
          {{ item.agentName }} <span v-if="props.isAudit">({{ settlementDateStart }} - {{ settlementDateEnd }})</span>
        </div>

        <el-table v-loading="loading" :row-class-name="tableRowClassName" class="normal-table" :border="true" :scrollbar-always-on="true" :data="[...item.agentTopCompanyList, ...item.agentTopAgentList]" :cell-style="initOperatorColumnStyle">
          <el-table-column align="center" prop="companyName" label="企业名称" :min-width="140" show-overflow-tooltip />
          <el-table-column align="center" prop="successAmount" label="企业支付金额(元)" :min-width="140" show-overflow-tooltip />
          <el-table-column align="center" prop="successSettleAmount" label="总结算金额(元)" :min-width="140" show-overflow-tooltip />
          <el-table-column align="center" prop="serverName" label="服务主体" :min-width="140" show-overflow-tooltip />
          <el-table-column align="center" prop="serviceRate" label="结算服务费率(%) " :min-width="140" show-overflow-tooltip />
          <el-table-column align="center" prop="protectLineRate" label="推广费率(%) " :min-width="140" show-overflow-tooltip />
          <el-table-column align="center" prop="agentRate" label="成本费率(%) " :min-width="140" show-overflow-tooltip />
          <el-table-column align="center" prop="outLineAmount" label="推广服务费(元)" :min-width="140" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.outLineAmount || 0 }}
              <el-tooltip
                v-if="scope.row.companyName==='合计'"
                class="auth-tooltip"
                effect="light"
                :content="`合计:${scope.row.outLineAmountOriginal}元&nbsp;&nbsp;&nbsp;&nbsp;扣点:${scope.row.promotionRate}%`"
                placement="top"
              >
                <svg-icon class="main-primary-text  !w-[16px] align-bottom" icon="mingcute:information-line" />
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="inLineAmount" label="溢价服务费(元)" :min-width="140" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.inLineAmount || 0 }}
              <el-tooltip
                v-if="scope.row.companyName==='合计'"
                class="auth-tooltip"
                effect="light"
                :content="`合计:${scope.row.inLineAmountOriginal}元&nbsp;&nbsp;&nbsp;&nbsp;扣点:${scope.row.promotionRate}%`"
                placement="top"
              >
                <svg-icon class="main-primary-text  !w-[16px] align-bottom" icon="mingcute:information-line" />
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>

    <OrderDetail v-if="activeKey === 'detail'" />
  </div>
</template>

<script setup lang="ts">
import OrderDetail from './components/OrderDetail.vue';
import { initOperatorColumnStyle, SvgIcon } from '@vue3/components';
import { exportDistributionTaskCompany, getCustomState, useTabsStore, useUserStore } from '@core/main';
import { } from '@core/main/types';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
import { ref, computed } from 'vue';
import { IDistributionSettlement } from '@core/main/types/crowd-source/commission-share';
import { cancelDistributionTask, exportDistributionTaskDetail, queryDistributionTaskDetailPage, submitDistributionTask } from '@core/main/api/crowd-source/commission-sharing';
import { downloadFile } from '@core/tools';
import { ESystemType } from '@core/api';

const route = useRoute();

const state = getCustomState<any>();

const { state: userState } = useUserStore();

const { closeAndBack } = useTabsStore();

const props = defineProps({
  refId: {
    type: Number,
    default: null,
  },
  isAudit: {
    type: Boolean,
    default: false,
  },
});

defineOptions({ name: 'TaskTempDetail' });

const id = computed(() => route.query.id);
const isSass = computed(() => userState.identity.systemType === ESystemType.SAAS);

const settlementDateStart = ref('');
const settlementDateEnd = ref('');

const loading = ref(false);
const tableData = ref<IDistributionSettlement[]>([]);
const tabs = ref([
  {
    name: '结算单',
    key: 'order',
  },
  {
    name: '结算明细',
    key: 'detail',
  },
]);
const activeKey = ref(route.query.activeKey as string || tabs.value[0]?.key);

function hanldeTab(key: string) {
  activeKey.value = key;

  key === 'order' ? fetchData() : undefined;
}

async function fetchData() {
  loading.value = true;
  try {
    const { data, settlementDateStart: start, settlementDateEnd: end } = await queryDistributionTaskDetailPage({ id: Number(id.value || props.refId) });

    tableData.value = data;
    settlementDateStart.value = start;
    settlementDateEnd.value = end;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  loading.value = false;
}

function getImageUrl(status: number) {
  switch (status) {
    case 0:
      return 'https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/web-example/caogao';
    case 1:
      return 'https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/web-example/shenhezhong';
    case 2:
      return 'https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/web-example/yitongguo';
    case 3:
      return 'https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/web-example/yibohui';
    case 4:
      return 'https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/web-example/yizuofei';

  }
}

async function exportData(type: string) {
  type === 'order' ? exportOrderData() : exportDetailData();
}

async function exportOrderData() {
  try {
    const { buffer, fileName } = await exportDistributionTaskDetail({ id: Number(id.value || props.refId) });

    downloadFile(buffer, fileName, 'xlsx');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function exportDetailData() {
  try {
    const { buffer, fileName } = await exportDistributionTaskCompany({ taskId: Number(id.value || props.refId) } as any);

    downloadFile(buffer, fileName, 'xlsx');
    ElMessage.success('导出成功');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function toCancel() {
  try {
    await cancelDistributionTask({ id: state.id });
    ElMessage.success('作废成功');
    closeAndBack();

  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}
async function toSubmit() {
  try {
    await submitDistributionTask({ id: state.id });
    ElMessage.success('提交成功');
    closeAndBack();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function tableRowClassName({ row }) {
  if (row.companyName === '合计' || row.companyName === '小计') {
    return 'bold-txt';
  }
  return '';

}

fetchData();

</script>

<style lang="scss" scoped>
:deep(.bold-txt) {
 font-weight: bold;
}
.title {
    @apply px-[16px] text-[20px] text-[var(--color-text-primary)] font-bold mb-[16px];
  }
</style>
